import { render, staticRenderFns } from "./platformData.vue?vue&type=template&id=e62fb234&scoped=true&"
import script from "./platformData.vue?vue&type=script&lang=js&"
export * from "./platformData.vue?vue&type=script&lang=js&"
import style0 from "./platformData.vue?vue&type=style&index=0&id=e62fb234&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e62fb234",
  null
  
)

export default component.exports